export default __webpack_public_path__ + "static/media/estado-21.c4918cb4.svg";